/**
 * Sort grouped category entries based on the admin-defined order.
 *   entries: Array<[string, Array<service>]> from Object.entries(groupedByCategory)
 *   order:   Array<string> from settings.category_order
 *
 * Categories present in `order` appear first in that order.
 * Categories not in `order` follow, sorted alphabetically (case-insensitive).
 */
export function sortCategoriesByOrder(entries, order) {
    const orderList = Array.isArray(order) ? order : [];
    const indexOf = (cat) => {
        const idx = orderList.findIndex((c) => c.toLowerCase() === cat.toLowerCase());
        return idx === -1 ? Number.POSITIVE_INFINITY : idx;
    };
    return [...entries].sort(([a], [b]) => {
        const ia = indexOf(a);
        const ib = indexOf(b);
        if (ia !== ib) return ia - ib;
        return a.localeCompare(b, undefined, { sensitivity: "base" });
    });
}
